import React, { useMemo, useContext } from 'react';
import GlobalContext from '../../../context/global';
import { trailingSlash } from '../../../utils';
import SendGridLink from '../../SendGridLink';
import ColumnHeader from '../ColumnHeader';
import { StyledContactUsBlock } from './styles';

const ContactUsBlock = ({ isLastBlock, title, subtitle, url, ctaText, ctaUrl, label, navigationState, setNavigationState }) => {
  const { location } = useContext(GlobalContext);

  const handleKeyDown = (isLastLink) => {
    return function (e) {
      if (isLastLink){
        console.log('keydown on last sub menu item');
        if (e.key==='Tab') {
          if (e.shiftKey) {
            // do nothing, default shift+tab focus event is desired
          } else {     
            e.preventDefault();
            e.stopPropagation();
            setNavigationState({
              ...navigationState,
              height: 0,
              current: null,
              departedFromSubMenu: label,
              stage: 'closed',
            });
          }    
        }
      }
    }
  }

  return (
    <StyledContactUsBlock>
      <ColumnHeader
        title={title}
        subtitle={subtitle}
        url={url}
      />
      <SendGridLink
        className={`arrow-link`}
        to={ctaUrl}
        dangerouslySetInnerHTML={{ __html: ctaText }}
        onKeyDown={handleKeyDown(isLastBlock)}
      />
    </StyledContactUsBlock>
  );
};

export default ContactUsBlock;
